<template>
    <div class="newestJotting">
        <span class="title">{{title}}</span>
        <div class="line"></div>
        <div class="split"></div>
        <div class="jotting">
            <div class="detail">
                <label>神不足惧，死不足忧，祸苦易忍，福乐易求。</label>
            </div>
            <div class="more">
                <label class="fl">2019年10月22日 23:00:22</label>
                <a class="fr" href="javascript:void(0)">赞(0)</a>
            </div>
        </div>
        <div class="split"></div>
        <div class="jotting">
            <div class="detail">
                <label>神不足惧，死不足忧，祸苦易忍，福乐易求。</label>
            </div>
            <div class="more">
                <label class="fl">2019年10月22日 23:00:22</label>
                <a class="fr" href="javascript:void(0)">赞(0)</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            required:false,
            default:'心随笔动'
        }
    },
    data (){
        return {
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/JottingList.vue